export function getQueryParams() {
  const params = new URLSearchParams(window.location.search);

  return {
    token: params.get("token"),
    id: params.get("id"),
    type: params.get("type"),
    redirect_status: params.get("redirect_status"),
    payment_intent: params.get("payment_intent"),
  };
}
